module.exports = __webpack_public_path__ + "static/media/keto-complete-package.9cd1c351.png";